import {
  GET_SALON_LIST, GET_SALON_LIST_COMPLETED, GET_SALON_LIST_FAILED,
  SELECT_SALON,
  ADD_SALON, ADD_SALON_COMPLETED, ADD_SALON_FAILED,
  UPDATE_SALON, UPDATE_SALON_COMPLETED, UPDATE_SALON_FAILED,
  GET_SALON, GET_SALON_COMPLETED, GET_SALON_FAILED,
  SEARCH_SALONS, SEARCH_SALONS_COMPLETED, SEARCH_SALONS_FAILED,
} from "./actions";
import {RESTORE_STATE} from "../persistState";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  salonList: [],
  salonListLoading: false,
  salonListError: null,
  salon: null,
  salonLoading: false,
  salonError: null,
  selectedSalonId: '',
  addingSalon: false,
  updatingSalon: false,
  search: searchDefault,
};

function salonReducer(state = defaultState, action) {
  switch (action.type) {
    case SEARCH_SALONS: return handleSearch(state, 'search', action.payload);
    case SEARCH_SALONS_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_SALONS_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case RESTORE_STATE: {
      const {selectedSalonId} = (action.payload && action.payload.salon) || {selectedSalonId: ''};
      return {
        ...state,
        selectedSalonId,
      };
    }
    case GET_SALON_LIST: {
      return {
        ...state,
        salonListLoading: true,
        salonList: [],
        salonListError: null,
      };
    }
    case GET_SALON_LIST_COMPLETED: {
      return {
        ...state,
        salonListLoading: false,
        salonList: action.payload.data,
      };
    }
    case GET_SALON_LIST_FAILED: {
      return {
        ...state,
        salonListLoading: false,
        salonListError: action.payload,
      };
    }
    case GET_SALON: {
      return {
        ...state,
        salonLoading: true,
        salon: null,
        salonError: null,
      };
    }
    case GET_SALON_COMPLETED: {
      return {
        ...state,
        salonLoading: false,
        salon: action.payload,
      };
    }
    case GET_SALON_FAILED: {
      return {
        ...state,
        salonLoading: false,
        salonError: action.payload,
      };
    }
    case SELECT_SALON: {
      return {
        ...state,
        selectedSalonId: action.payload.salonId,
      };
    }
    case ADD_SALON: {
      return {
        ...state,
        addingSalon: true,
      };
    }
    case ADD_SALON_COMPLETED: {
      return {
        ...state,
        addingSalon: false,
      };
    }
    case ADD_SALON_FAILED: {
      return {
        ...state,
        addingSalon: false,
      };
    }
    case UPDATE_SALON: {
      return {
        ...state,
        updatingSalon: true,
      };
    }
    case UPDATE_SALON_COMPLETED: {
      return {
        ...state,
        updatingSalon: false,
      };
    }
    case UPDATE_SALON_FAILED: {
      return {
        ...state,
        updatingSalon: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
}

export default salonReducer;



// WEBPACK FOOTER //
// ./src/Salon/reducer.js